import { HttpContext, HttpContextToken, HttpInterceptorFn } from '@angular/common/http';

/** Cabeçalho lido pelo `IdempotenciaFilter` do sicom-api. */
export const CABECALHO_IDEMPOTENCIA = 'X-Idempotency-Key';

/** Chave de idempotência da requisição. Vazio = sem proteção, que é o padrão. */
export const CHAVE_IDEMPOTENCIA = new HttpContextToken<string | null>(() => null);

/**
 * Gera a chave de uma **sessão de formulário** — abriu o diálogo (ou entrou em edição), gerou uma.
 *
 * <p>A escolha da granularidade é o que faz a proteção funcionar ou virar enfeite:</p>
 *
 * <ul>
 *   <li><b>UUID por requisição:</b> inútil. O segundo clique geraria outra chave e passaria direto.</li>
 *   <li><b>Hash do payload:</b> pega o duplo clique, mas engole a duplicata proposital — duas
 *       anotações idênticas de propósito, dentro do TTL, viram uma só.</li>
 *   <li><b>Por sessão de formulário:</b> cobre os quatro casos. Duplo clique reusa a chave e é
 *       recusado; corrigir depois de um 400 funciona porque o backend liberou a chave na falha;
 *       resposta perdida não regrava; e duplicar de propósito é reabrir o formulário, que gera
 *       chave nova.</li>
 * </ul>
 */
export function novaChaveIdempotencia(): string {
    return crypto.randomUUID();
}

/** Contexto pronto para passar aos métodos de service, que já aceitam `HttpContext`. */
export function comIdempotencia(chave: string, base: HttpContext = new HttpContext()): HttpContext {
    return base.set(CHAVE_IDEMPOTENCIA, chave);
}

/**
 * Converte a chave do contexto em cabeçalho. Sem chave, a requisição segue sem proteção — o filtro
 * do backend também é opt-in, então o rollout pode ser tela a tela sem quebrar nada.
 */
export const idempotenciaInterceptor: HttpInterceptorFn = (req, next) => {
    const chave = req.context.get(CHAVE_IDEMPOTENCIA);
    if (!chave) {
        return next(req);
    }
    return next(req.clone({ setHeaders: { [CABECALHO_IDEMPOTENCIA]: chave } }));
};
